import { useEffect } from 'react';
import { create } from 'zustand';

/**
 * What the player is looking at, for global overlays: `games` > 0 while a game screen (GameShell) is mounted.
 * Social toasts are quiet then (honest play: nothing gets in the way of a round).
 */
export const useScreen = create<{ games: number }>()(() => ({ games: 0 }));

export const selectInGame = (s: { games: number }): boolean => s.games > 0;

/** GameShell: marks "in a game" while mounted */
export function useInGameMark(): void {
  useEffect(() => {
    useScreen.setState((s) => ({ games: s.games + 1 }));
    return () => useScreen.setState((s) => ({ games: s.games - 1 }));
  }, []);
}
